// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../../graphql/api/index';

export const QuestionnaireConditionIsEqualToFragmentDoc = `
    fragment questionnaireConditionIsEqualTo on QuestionnaireConditionIsEqualTo {
  __typename
  question {
    id
  }
  valueString: value
}
    `;